import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { IQuoteState, IQuoteItem } from './interface';
import { ERequestStatus } from 'src/api/enumRequest';

const quoteState = (state: any) => state.quote;

export const selectCreatedQuote: (state: any) => IQuoteItem | null = createDraftSafeSelector(
  quoteState,
  (state: IQuoteState) => state.createQuote.quote
);

export const selectStatusCreateQuote: (state: any) => ERequestStatus = createDraftSafeSelector(
  quoteState,
  (state: IQuoteState) => state.createQuote.status
);

export const selectErrorCreateQuote: (state: any) => string = createDraftSafeSelector(
  quoteState,
  (state: IQuoteState) => state.createQuote.error
);
